import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { api } from '@/lib/api';
import { eur, STATUS_LABELS, STATUS_COLORS, fmtDate } from '@/lib/format';
import { PublicHeader, Footer } from '@/components/Header';

export default function MyOrdersPage() {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get('/orders/me').then(r => setOrders(r.data)).catch(() => setOrders([]));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1 max-w-4xl mx-auto px-4 py-10 w-full">
        <h1 className="font-display text-3xl font-bold mb-6">I miei ordini</h1>
        {orders.length === 0 ? (
          <div className="rounded-2xl bg-white border border-[--brand-border] p-8 text-center text-[--brand-muted]">Nessun ordine ancora.</div>
        ) : (
          <div className="space-y-3">
            {orders.map(o => (
              <Link key={o.id} to={`/tracking/${o.id}`} className="block rounded-2xl bg-white border border-[--brand-border] p-4 shadow-[var(--shadow-sm)] hover:shadow-[var(--shadow-md)] transition" data-testid="my-orders-item">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold">Ordine #{o.order_number}</div>
                    <div className="text-xs text-[--brand-muted]">{fmtDate(o.created_at)}</div>
                  </div>
                  <Badge className={`${STATUS_COLORS[o.status]} border rounded-full px-3`}>{STATUS_LABELS[o.status]}</Badge>
                </div>
                <div className="mt-2 text-sm text-[--brand-muted]">{o.delivery_address}</div>
                <div className="mt-2 flex items-center justify-between">
                  <div className="text-xs text-[--brand-muted]">{o.items.length} articoli</div>
                  <div className="font-display font-bold tabular-nums text-[--brand-primary]">{eur(o.total)}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
